import request from "./request"

export function sendEmailCode(data) {
  return request({
    url: "/auth/code_send",
    method: "post",
    data
  })
}

export function registerAccount(data) {
  return request({
    url: "/auth/register",
    method: "post",
    data
  })
}

export function loginAccount(data) {
  return request({
    url: "/auth/login",
    method: "post",
    data,
    skipAuthRedirect: true
  })
}

export function passwordLogin(data) {
  return request({
    url: "/auth/password_login",
    method: "post",
    data,
    skipAuthRedirect: true
  })
}

export function resetPassword(data) {
  return request({
    url: "/auth/password_reset",
    method: "post",
    data
  })
}

export function getProfile() {
  return request({
    url: "/auth/profile_get",
    method: "get"
  })
}

export function logoutAccount() {
  return request({
    url: "/auth/logout",
    method: "post"
  })
}

export function addInteraction(data) {
  return request({
    url: "/auth/interaction_add",
    method: "post",
    data
  })
}
